import { useState, useContext } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { GridColumn } from "@progress/kendo-react-grid";
import { Window } from '@progress/kendo-react-dialogs';
import { FilterDescriptor, SortDescriptor } from "@progress/kendo-data-query";
import { protectedResources } from '../../authConfig';
import { BaseGrid } from '../../components/KendoGrid/BaseGrid';
import { useNotificationAPI } from "../../components/NotificationProvider";
import { useFetchWithMsal } from "../../hooks/useFetchWithMsal";
import { AppUserContext } from '../../components/PvsContextProvider';

interface AppUserLabListProps {
    labId?: number,
    children?: React.ReactNode
}

const AppUserLabList = (props: AppUserLabListProps) => {
    let gridFilter = undefined as FilterDescriptor[] | undefined;
    const [appUserLab, setAppUserLab] = useState(undefined as any);
    const notifcations = useNotificationAPI();
    const appUserContext = useContext(AppUserContext);
    const { execute } = useFetchWithMsal({
        scopes: protectedResources.scopes.admin
    });

    if (props.labId) {
        gridFilter = [{
            field: "labId",
            operator: "eq",
            value: props.labId,
        }] as FilterDescriptor[];
    } else {
        gridFilter = undefined;
    }

    const alphabeticalSort = [{
        field: "appUser.email",
        dir: "asc"
    } as SortDescriptor];

    const removeAppUserLab = () => {
        execute("DELETE", protectedResources.apiAppUserLab.endpoint + "DeleteAppUserLab", { Id: appUserLab.id }, undefined).then((data: any) => {
            if (data?.notifications && !data?.notifications.hasErrors) {
                notifcations.addNotification(appUserLab?.appUser?.email + ' removed from lab.', 'App User Lab List', 'success');
                setAppUserLab(undefined);
            }
        })
    }

    const DateCell = (myDate: any) => {
        let formattedDate = new Date(myDate.dataItem.createdOn).toLocaleDateString()
        return (
            <td>
                {formattedDate}
            </td>
        )
    }

    const removeAppUserLabCell = (props: any) => {
        return (
            <td>
                <Button onClick={() => { setAppUserLab(props?.dataItem); }}>
                    Remove User
                </Button>
            </td>
        )
    }

    return (
        <>
            {appUserLab !== undefined &&
                <Window onClose={() => { setAppUserLab(undefined); }}>
                    Are you sure you want to remove {appUserLab.appUser.email} from the lab? <br></br><br></br>
                    <Button onClick={removeAppUserLab}>Remove</Button>
                </Window>}
            {!appUserContext.isStreckAdmin &&
                <>
                    To remove a user from this lab, please contact the STATs team.
                </>}
            <BaseGrid filter={gridFilter} intialSort={alphabeticalSort} verb={'POST'} pageTitle='Users in Lab' endpoint={protectedResources.apiAppUserLab.endpoint + "KendoGridRead"}>
                <GridColumn field="appUser.email" title="Email" />
                <GridColumn field="createdOn" cell={DateCell} title="Joined Date" />
                {appUserContext.isStreckAdmin &&
                    <GridColumn width="150px" cell={removeAppUserLabCell} filterable={false} sortable={false} />}
            </BaseGrid>
        </>
    );
}

export default AppUserLabList;